import { toQuery } from '@/utils/infrastructure';
import request from '@/utils/infrastructure/communication/request';

export async function queryEditActive(id) {
  return request.post(`/reportGroup/activate/${id}`, {});
}

export async function queryEditPath(data, id) {
  return request.patch(`/reportGroup/${id}`, {
    data,
  });
}

export async function queryListPermissions(payload) {
  return request(`/${payload.route}`, {
    params: toQuery(payload.params),
  });
}

export async function querySavePermission(payload) {
  return request.post(`/reportGroup/updatePermissions/${payload.id}`, {
    data: payload.data,
  });
}
